import { render, staticRenderFns } from "./modifyCompany.vue?vue&type=template&id=de6d58a2&scoped=true&"
import script from "./modifyCompany.vue?vue&type=script&lang=js&"
export * from "./modifyCompany.vue?vue&type=script&lang=js&"
import style0 from "./modifyCompany.vue?vue&type=style&index=0&id=de6d58a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6d58a2",
  null
  
)

export default component.exports